import React from "react";
import { format } from "date-fns";

import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import Loading from "./Loading";

const Project = ({ project, onClick }) => {
  const theme = useTheme();

  if (!project) return <Loading />;

  return (
    <Box
      sx={{
        border: "solid #ccc 1px",
        paddingLeft: "6px",
        paddingRight: "6px",
        paddingTop: "4px",
        paddingBottom: "4px",
        borderRadius: "4px",
        boxShadow: theme.shadows[4],
        cursor: "pointer",
      }}
      onClick={() => onClick(project.id)}
    >
      <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
        {project.name}
      </Typography>
      <Box
        sx={{ display: "flex" }}
        gap={1}
      >
        <Typography sx={{ fontSize: "10px" }}>{`Starts: ${
          project.startsOn ? format(project.startsOn, "MMM dd") : "Not set"
        }`}</Typography>
        <Typography sx={{ fontSize: "10px" }}>{`Ends: ${
          project.endsOn ? format(project.endsOn, "MMM dd") : "Not set"
        }`}</Typography>
      </Box>
    </Box>
  );
};

export default Project;
